import { FAILURE, IDLE, REQUEST, SUCCESS } from 'src/redux/constants';
import { ADD_IMAGES, DELETE_IMAGES } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { AddImagesDataActionTypes } from './types';
import fileApi from 'src/utils/api/fileApi';

export const loadAddImages =
  (
    td: FormData,
  ): ThunkAction<Promise<void>, State, null, AddImagesDataActionTypes> =>
  async (dispatch: any) => {
    dispatch({ type: ADD_IMAGES + REQUEST });
    try {
      const payload = await fileApi.loadAddImages(td);
      dispatch({ type: ADD_IMAGES + SUCCESS, payload });
    } catch (error) {
      dispatch({ type: ADD_IMAGES + FAILURE, error });
    }
  };

export const addImagesIdle = () => ({ type: ADD_IMAGES + IDLE });

export const addImageDelete = (id: number) => ({
  type: DELETE_IMAGES,
  payload: id,
});
